import {  relativeToTheTotalArea } from "../soil/soilMapHelper"

export const proposition1UiHelper = (persianName, parameterMapInfo) => {
    if (parameterMapInfo?.mapInfo?.ranges[0]?.min === parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max) {
        return `بر اساس بازدید حضوری کارشناس و خروجی نقشه‌های ارزیابی, ${persianName} به میزان ${parameterMapInfo?.stationQuestion?.answer} ${parameterMapInfo?.stationQuestion?.typeDesc.trim() !== "اگرونومیک" ? "درصد" : ""} در این قطعه زمین گزارش شده است.`
    }
    return `بر اساس بازدید حضوری کارشناس و خروجی نقشه‌های ارزیابی، ${persianName} از ${parameterMapInfo?.mapInfo?.ranges[0]?.min} تا ${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max} ${parameterMapInfo?.stationQuestion?.typeDesc.trim() !== "اگرونومیک" ? "درصد" : ""} در این قطعه زمین گزارش شده است.`
}

export const isShowProposition2UiHelper = (parameterMapInfo) => {
    const minRange = parameterMapInfo?.mapInfo?.ranges[0]?.min === 0 ? 1 : parameterMapInfo?.mapInfo?.ranges[0]?.min
    if (parameterMapInfo?.mapInfo?.ranges?.length === 1) {
        return false
    }
    if (parameterMapInfo?.mapInfo?.ranges[0]?.min > 0 && parameterMapInfo?.mapInfo?.ranges[0]?.min < 20) {
        if ((parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max / minRange) < 2.5) {
            return false
        }
    }
    if (parameterMapInfo?.mapInfo?.ranges[0]?.min > 20 && parameterMapInfo?.mapInfo?.ranges[0]?.min < 100) {
        if ((parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max / minRange) < 2) {
            return false
        }
    }
    return true
}

export const proposition2UiHelper = (persianName, parameterMapInfo) => {
    return `کمترین میزان ${persianName} از ${parameterMapInfo?.mapInfo?.ranges[0]?.min} تا ${parameterMapInfo?.mapInfo?.ranges[0]?.max} در محدوده ${parameterMapInfo?.mapInfo?.ranges[0]?.label} و بیشترین مقدار آن از ${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.min} تا ${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max} ${parameterMapInfo?.stationQuestion?.typeDesc.trim() !== "اگرونومیک" ?  "درصد" : "" } در محدوده ${parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.label} که به ترتیب ${relativeToTheTotalArea(parameterMapInfo?.mapInfo?.percentage[0], parameterMapInfo?.mapInfo)} و ${relativeToTheTotalArea(parameterMapInfo?.mapInfo?.percentage[parameterMapInfo?.mapInfo?.percentage?.length - 1], parameterMapInfo?.mapInfo)} درصد مساحت کل زمین را پوشش می‌دهد.`
}

// export const isShowProposition3UiHelper = (parameterMapInfo) => {
//     if (
//         (parameterMapInfo?.mapInfo?.ranges?.length === 1 || parameterMapInfo?.mapInfo?.ranges?.length === 2) &&
//         (
//             (parameterMapInfo?.stationQuestion?.typeDesc === 'آفت' && (parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max < 8 || parameterMapInfo?.mapInfo?.ranges[0]?.min < 8)) ||
//             (parameterMapInfo?.stationQuestion?.typeDesc === 'بیماری (قارچ)' && (parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max < 5 || parameterMapInfo?.mapInfo?.ranges[0]?.min < 5)) ||
//             (parameterMapInfo?.stationQuestion?.typeDesc === 'فیزیولوژیک' && (parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max < 10 || parameterMapInfo?.mapInfo?.ranges[0]?.min < 10))
//         )
//     ) {
//         return false
//     }
//     return true
// }

// export const proposition3UiHelper = (persianName, area, parameterMapInfo) => {
//     let acceptedRanges = []
//     let totalArea = 0
//     parameterMapInfo?.mapInfo?.ranges?.forEach((range, i) => {
//         if (parameterMapInfo?.stationQuestion?.typeDesc === 'آفت') {
//             if (range?.max > 8 || range?.min > 8) {
//                 acceptedRanges.push(range)
//                 totalArea += calculateArea(parameterMapInfo?.mapInfo?.percentage[i], area)
//             }
//         }
//         if (parameterMapInfo?.stationQuestion?.typeDesc === 'بیماری (قارچ)') {
//             if (range?.max > 5 || range?.min > 5) {
//                 acceptedRanges.push(range)
//                 totalArea += calculateArea(parameterMapInfo?.mapInfo?.percentage[i], area)
//             }
//         }
//         if (parameterMapInfo?.stationQuestion?.typeDesc === 'فیزیولوژیک') {
//             if (range?.max > 10 || range?.min > 10) {
//                 acceptedRanges.push(range)
//                 totalArea += calculateArea(parameterMapInfo?.mapInfo?.percentage[i], area)
//             }
//         }
//     })
//     if (
//         (parameterMapInfo?.mapInfo?.ranges?.length === 1 || parameterMapInfo?.mapInfo?.ranges?.length === 2) &&
//         (
//             (parameterMapInfo?.stationQuestion?.typeDesc === 'آفت' && (parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max > 8 || parameterMapInfo?.mapInfo?.ranges[0]?.min > 8)) ||
//             (parameterMapInfo?.stationQuestion?.typeDesc === 'بیماری (قارچ)' && (parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max > 5 || parameterMapInfo?.mapInfo?.ranges[0]?.min > 5)) ||
//             (parameterMapInfo?.stationQuestion?.typeDesc === 'فیزیولوژیک' && (parameterMapInfo?.mapInfo?.ranges[parameterMapInfo?.mapInfo?.ranges?.length - 1]?.max > 10 || parameterMapInfo?.mapInfo?.ranges[0]?.min > 10))
//         )
//     ) {
//         return 'در تمام مساحت زمین، آفت شته مشاهده می‌شود.'
//     }
//     return `در ${parseFloat(totalArea?.toFixed(2))} هکتار از زمین شما شامل ${acceptedRanges.length === 1 ? 'محدوده' : 'محدوده های'} ${acceptedRanges.map(rangeLabel => rangeLabel?.label)?.join(', ')} به میزان نسبتاً زیادی ${persianName} مشاهده می‌شود.`
// }

export const isShowExpertSuggestionProposition1UiHelper = (visitStationQuestionsData) => {
    const disasterTypeDescriptions = visitStationQuestionsData?.filter(disasterTypeDesc => disasterTypeDesc?.stationQuestion?.typeDesc === 'آفت')
    if (disasterTypeDescriptions?.length >= 1) {
        return true
    }
    return false
}

export const expertSuggestionProposition1UiHelper = (visitStationQuestionsData) => {
    const disasterTypeDescriptions = visitStationQuestionsData?.filter(disasterTypeDesc => disasterTypeDesc?.stationQuestion?.typeDesc === 'آفت')
    return `توصیه می‌شود در نقشه‌های آفات (${disasterTypeDescriptions?.map(disasterTypeDesc => disasterTypeDesc?.stationQuestion?.persianName)?.join(', ')}) برای محدوده‌های بالای 8 درصد حضور آفت، اقدامات لازم جهت کنترل زیر نظر گیاهپزشک متخصص و حاذق انجام شود.`
}

export const isShowExpertSuggestionProposition2UiHelper = (visitStationQuestionsData) => {
    const sicknessTypeDescriptions = visitStationQuestionsData?.filter(disasterTypeDesc => disasterTypeDesc?.stationQuestion?.typeDesc === 'بیماری (قارچ)')
    if (sicknessTypeDescriptions?.length >= 1) {
        return true
    }
    return false
}

export const expertSuggestionProposition2UiHelper = (visitStationQuestionsData) => {
    const sicknessTypeDescriptions = visitStationQuestionsData?.filter(disasterTypeDesc => disasterTypeDesc?.stationQuestion?.typeDesc === 'بیماری (قارچ)')
    return `پیشنهاد می‌شود در نقشه‌های بیماری ها (${sicknessTypeDescriptions?.map(sicknessTypeDesc => sicknessTypeDesc?.stationQuestion?.persianName)?.join(', ')}) برای محدوده های بالای 5 درصد خسارت بیماری، اقدامات لازم جهت کنترل زیر نظر گیاهپزشک متخصص و حاذق انجام شود.`
}

export const isShowExpertSuggestionProposition3UiHelper = (visitStationQuestionsData) => {
    const physiologicTypeDescriptions = visitStationQuestionsData?.filter(disasterTypeDesc => disasterTypeDesc?.stationQuestion?.typeDesc === 'فیزیولوژیک')
    if (physiologicTypeDescriptions?.length >= 1) {
        return true
    }
    return false
}

export const expertSuggestionProposition3UiHelper = (visitStationQuestionsData) => {
    const physiologicTypeDescriptions = visitStationQuestionsData?.filter(disasterTypeDesc => disasterTypeDesc?.stationQuestion?.typeDesc === 'فیزیولوژیک')
    return `در نقشه‌های (${physiologicTypeDescriptions?.map(physiologicTypeDesc => physiologicTypeDesc?.stationQuestion?.persianName)?.join(', ')}) برای محدوده‌های بالای 10 درصد، موارد با نظر کارشناس مزرعه بررسی و اقدامات لازم انجام شود.`
}